export default __webpack_public_path__ + "media/images/info_warning_16-45b3565c0ac090fe870d6eedd86c7373.png";